module.exports = {
    AccidentImageTypesNames: [
        'רכב',
        'רשיון רכב',
        'ביטוח',
        'רשיון נהיגה',
        'אחר',
    ],
};
